import { useQuery } from "@tanstack/react-query";
import { api } from "@/api/client";
import { SiteHeader } from "@/components/SiteHeader";
import { HeroSection } from "@/components/HeroSection";
import { FeaturedArtists } from "@/components/FeaturedArtists";
import { ReservationSection } from "@/components/ReservationSection";
import { CatalogPromo } from "@/components/CatalogPromo";
import { GallerySection } from "@/components/GallerySection";
import { LocationSection } from "@/components/LocationSection";
import { ElfsightReviews } from "@/components/ElfsightReviews";
import { SiteFooter } from "@/components/SiteFooter";

export default function HomePage() {
  const { data, isLoading, isError } = useQuery({ queryKey: ["site"], queryFn: async () => (await api.get("/site")).data });
  if (isLoading) return <div className="route-loader" data-testid="site-loading-state">OKUME</div>;
  if (isError) return <div className="route-error" data-testid="site-error-message">No pudimos cargar Okume. Inténtalo de nuevo en unos segundos.</div>;
  return (
    <main className="public-site" data-testid="home-page">
      <SiteHeader logoUrl={data.settings.logoUrl} transparent />
      <HeroSection settings={data.settings} />
      <FeaturedArtists artists={data.artists} />
      <ReservationSection />
      <CatalogPromo songCount={data.songCount} />
      <GallerySection images={data.gallery} />
      <LocationSection />
      <ElfsightReviews />
      <SiteFooter logoUrl={data.settings.logoUrl} />
    </main>
  );
}
